
// Hamburger Animation
$(".hamburger").click(function() {
    $( this ).toggleClass( "is-active" );
});

$(".js-nav-control" ).click(function() {
    $('body').toggleClass('open');
});


// SEARCH 
$('.user-icons').on("click", function(e) {
    $('#search-pop').hide();
});

//VARIANT IMAGE CHANGE
$('.radionewvariation').click(function() {
  if($(this).data('image')){
    $(this).parent().parent().parent().parent().find('.product-grid-image-img').attr('src', $(this).data('image'))
  }
})


$("body").on("click", '.js-show-search, .search-close', function(e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }

    $('#search-pop').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});
    

// QTY Adjust
  
/* JS Quantity Incrementers */
// jQuery(function(){
//     var j = jQuery; 
//     var addInput = '.js-qty-wrap'; 

//     j(addInput).each(function() { 
//         var inputEl = j(this).closest(addInput).find('input');
//         var n = inputEl.val(); 
//         var plusEl = j(this).closest(addInput).find('.plus');
//         var minEl = j(this).closest(addInput).find('.min');
//         //On plus click add 1 to n
//         plusEl.on('click', function(){
//             inputEl.val(++n);
//         });
//         //On min click 
//         minEl.on('click', function(){
//         //If n is bigger or equal to 1 subtract 1 from n 
//             if ( ( inputEl.val() ) >= 1) {
//             inputEl.val(--n);
//             }
//           else if( inputEl.val() == 0)
//           {
//              inputEl.val(1);
//           }
//         });
//     });
// });
    
jQuery(function(){
    var j = jQuery; 
    var addInput = '.js-qty-wrap'; 

    j(addInput).each(function() { 
        var inputEl = j(this).find('input');
        var plusEl = j(this).find('.plus');
        var minEl = j(this).find('.min');
        
        // On plus click add 1 to n
        plusEl.on('click', function(){
            var n = parseInt(inputEl.val());
            inputEl.val(++n);
        });

        // On min click
        minEl.on('click', function(){
            var n = parseInt(inputEl.val());
            // If n is bigger than 1, subtract 1 from n 
            if (n > 1) {
                inputEl.val(--n);
            } else {
                // If n is 0, reset it to 1
                inputEl.val(1);
            }
        });
    });
});
$(document).ready(function(){
  
    var myCarousel = $(".js-carousel");
    myCarousel.each(function() {        
        $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            dots:false,
            prevArrow: "<a href='#' class='collection-carousel-arrow collection-carousel-arrow-prev'><i class='arrow-icon'></i><span class='visually-hidden'>Previous slide</span></a>",
            nextArrow: "<a href='#' class='collection-carousel-arrow collection-carousel-arrow-next'><i class='arrow-icon'></i><span class='visually-hidden'>Next slide</span></a>",
            responsive: [     
          {
              breakpoint: 1200,
              settings: {
                   slidesToShow: 3,
                   slidesToScroll: 3,
              }
            },
            {
                breakpoint: 1024,
                settings: {
                     slidesToShow: 2,
                     slidesToScroll: 2,
                }
              },
                {
              breakpoint: 768,
              settings: {
                   slidesToShow: 1,
                   slidesToScroll: 2,
              }
            },
            {
              breakpoint: 600,
                centerMode: true,
                centerPadding: '60px',
                  settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:true,
                arrows:false,

              }
            }
          ]
        });
      }); 
    });	
    
    
 

// PDP CAROUSEL WITH THUMBS
if ( $('.js-slider-primary').length ) {
  var initSlide = 0;

  $('.js-slider-primary').find('.single-photo').each(function() {
    if ( $(this).data('init') !== undefined ) {
      initSlide = parseInt($(this).data('init'));
      return;
    }
  })

  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    infinite: true,
    initialSlide: initSlide,
    asNavFor: '.js-slider-thumbs',
    responsive: [     
      {
        breakpoint: 600,
        centerMode: false,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          arrows:false,
        }
      }
    ]
  });
}
if ( $('.js-slider-thumbs').length ) {
  $('.js-slider-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite:true,
    variableWidth: false,
    arrows: true,
    prevArrow: "<a href='#' class='previous-arrow'><i class='carousel-arrow carousel-arrow-prev'></i><span class='visually-hidden'>Previous slide</span></a>",
    nextArrow: "<a href='#' class='next-arrow'><i class='carousel-arrow carousel-arrow-next'></i><span class='visually-hidden'>Next slide</span></a>",
  });
}



// Footer Nav

function resizeHandler() {
  if ($(window).width() < 992) {
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
        
    
  } else{
    $('.footer-nav ul').show();
    $('.footer-nav-header').removeClass("expanded");
  }
  
  if ($(window).width() < 768) {
    $('.js-nutrition-content').hide();
    $('.js-nutrition-content').slideUp(200);
        
    
  } else{
    $('.js-nutrition-content').show();
    $('.js-nutrition-title').removeClass("expanded");
  }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 992) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});

$('body').on('click', '.js-nutrition-title', function() { 
  if ($(window).width() < 768) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});

$(document).ready(function() { 
  var updateProductImage = function(selectedOption) {
    // Update Product Photos Slider 
    var variantImage = selectedOption.getAttribute('data-image');
    
    var position = -1;

    $('.single-product-photo .single-photo').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });

    $('.product-thumbs .single-thumb').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });

    if ( position != -1 ) { 
      $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
    }
  }

  $('.js_productSelect').change(function(event) {
    var selected = this.options[this.selectedIndex];

    updateProductImage(selected);
  })

  /*
  $(window).on('load', function(event) {
    // Check if it's Product page
    if ( $(`#product-top`).length ) {
      var $variantSelector = $(`.js_productSelect`);
      if ( $variantSelector.length ) {
        var selectedOption = $variantSelector[0].options[$variantSelector[0].selectedIndex];
  
        updateProductImage(selectedOption);
      }
    }
  })
  */
})


    $(document).ready(function() {
      $('.select__select.col').on('change', function() {
        
        var selectedOption = $(this).find('option:selected');
        var productHandle = $(this).find(':selected').data('handle');
        console.log(productHandle);
        if (selectedOption.hasClass('variant-sold-out')) {
          $('.add-to-cart[data-handle="'+ productHandle +'"]').prop('disabled', true);
          $('.add-to-cart[data-handle="'+ productHandle +'"] span').text('Sold Out');
          $('.klaviyo-product-container[data-handle="'+ productHandle +'"]').css('display', 'block');
        }
        else {
          $('.add-to-cart[data-handle="'+ productHandle +'"]').prop('disabled', false);
          $('.add-to-cart[data-handle="'+ productHandle +'"] span').text('Add to Cart');
          $('.klaviyo-product-container[data-handle="'+ productHandle +'"]').css('display', 'none');
        }
      });
      
    });

    $(document).ready(function() {
      // Remove the inline style from the element
      $('.klaviyo-button-container').removeAttr('style');

    });